import type { ReactNode } from 'react'
import type { PublicView } from '@sh/shared'
import { Board } from './Board.js'

/**
 * The board, docked under the controls on every game screen.
 *
 * It used to be collapsed, on the grounds that the action should stay above the
 * fold. What that actually bought was a table where nobody knew the score: the
 * board is the thing being argued about, and a summary line reading "L 2/5 · F
 * 3/6" is not the board. So it is simply always here, and below the controls
 * rather than above them - the thing you have to act on first, the thing you
 * have to think about underneath it. There is no toggle: a board you can close
 * is a board somebody closes and then plays blind, and the counts the old
 * collapsed header carried are already on the tracks themselves.
 */
export function BoardPanel({ view, secret }: { view: PublicView; secret?: ReactNode }) {
  return (
    <section className="panel panel--board">
      <Board view={view} secret={secret} />
    </section>
  )
}
